export const getNoShowReportsByMemberQueryFn = (member_id: string) => {
  const query = `
  getNoShowReportsByMember(member_id: $member_id) {
    ... on NoShowReport {
      status
      type
      PK
      court_id
      date
      member_id
      resolved_at
      resolved_reason
      slot_datetime_start
      comment
    }
    ... on Error {
      code
      message
    }
  }
`;
  const inputs = `$member_id: String!`;
  const variables = { member_id };
  return {
    inputs,
    variables,
    query,
  };
};

export const updateNoShowReportCommentQueryFn = (
  PK: string,
  date: string,
  comment: string
) => {
  const query = `
    updateNoShowReportComment(PK: $PK, date: $date, comment: $comment) {
         ... on NoShowReport {
            status
            type
            PK
            court_id
            date
            member_id
            resolved_at
            resolved_reason
            slot_datetime_start
            comment
            }
        ... on Error {
            code
            message
        }
    }
    `;
  const inputs = `$PK: String!, $date: String!, $comment: String!`;
  const variables = { PK, date, comment };
  return {
    inputs,
    variables,
    query,
  };
};

export const activateNoShowReportQueryFn = (
  PK: string,
  date: string,
  member_id: string
) => {
  const query = `
        activateNoShowReport(PK: $PK, date: $date, member_id: $member_id) {
            ... on NoShowReport {
                status
                type
                PK
                court_id
                date
                member_id
                resolved_at
                resolved_reason
                slot_datetime_start
                comment
            }
            ... on Error {
                code
                message
            }
        }
    `;
  const inputs = `$PK: String!, $date: String!, $member_id: String!`;
  const variables = { PK, date, member_id };
  return {
    inputs,
    variables,
    query,
  };
};

export const resolveNoShowReportQueryFn = (
  PK: string,
  date: string,
  member_id: string
) => {
  const query = `
        resolveNoShowReport(PK: $PK, date: $date, member_id: $member_id) {
            ... on NoShowReport {
                status
                type
                PK
                court_id
                date
                member_id
                booking_id
                resolved_at
                resolved_reason
                slot_datetime_start
                comment
            }
            ... on Error {
                code
                message
            }
        }
    `;
  const inputs = `$PK: String!, $date: String!, $member_id: String!`;
  const variables = { PK, date, member_id };
  return {
    inputs,
    variables,
    query,
  };
};
